const { createSelector } = require('reselect')

const selectSpecificationList = state => state.specification.specificationList
const getSpecificationList = () => createSelector(
  [selectSpecificationList],
  cse => cse.data,
)
const getSpecificationListError = () => createSelector(
  [selectSpecificationList],
  cse => cse.error,
)
const getSpecificationListLoading = () => createSelector(
  [selectSpecificationList],
  cse => cse.loading,
)

const selectSpecification = state => state.specification.specification
const getSpecification = () => createSelector(
  [selectSpecification],
  cse => cse.data,
)
const getSpecificationError = () => createSelector(
  [selectSpecification],
  cse => cse.error,
)
const getSpecificationLoading = () => createSelector(
  [selectSpecification],
  cse => cse.loading,
)

const selectCreate = state => state.specification.create
const getCreateSpecification = () => createSelector(
  [selectCreate],
  cse => cse.data,
)
const getCreateSpecificationError = () => createSelector(
  [selectCreate],
  cse => cse.error,
)
const getCreateSpecificationLoading = () => createSelector(
  [selectCreate],
  cse => cse.loading,
)

const selectUpdate = state => state.specification.update
const getUpdateSpecification = () => createSelector(
  [selectUpdate],
  cse => cse.data,
)
const getUpdateSpecificationError = () => createSelector(
  [selectUpdate],
  cse => cse.error,
)
const getUpdateSpecificationLoading = () => createSelector(
  [selectUpdate],
  cse => cse.loading,
)

const selectDelete = state => state.specification.delete
const getDeleteSpecificationRes = () => createSelector(
  [selectDelete],
  cse => cse.data,
)
const getDeleteSpecificationError = () => createSelector(
  [selectDelete],
  cse => cse.error,
)
const getDeleteSpecificationLoading = () => createSelector(
  [selectDelete],
  cse => cse.loading,
)

const selectSpecificationPriceState = state => state.specification.getSpecificationPriceState
const getSpecificationPriceData = () => createSelector(
  [selectSpecificationPriceState],
  cse => cse.data,
)
const getSpecificationPriceDataError = () => createSelector(
  [selectSpecificationPriceState],
  cse => cse.error,
)
const getSpecificationPriceDataLoading = () => createSelector(
  [selectSpecificationPriceState],
  cse => cse.loading,
)

module.exports = {
  getSpecificationList,
  getSpecificationListError,
  getSpecificationListLoading,
  getSpecification,
  getSpecificationError,
  getSpecificationLoading,
  getCreateSpecification,
  getCreateSpecificationError,
  getCreateSpecificationLoading,
  getUpdateSpecification,
  getUpdateSpecificationError,
  getUpdateSpecificationLoading,
  getDeleteSpecificationRes,
  getDeleteSpecificationError,
  getDeleteSpecificationLoading,
  getSpecificationPriceData,
  getSpecificationPriceDataError,
  getSpecificationPriceDataLoading,
}
